import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Index from '../views/Index.vue'
import Diagnosis from '../views/diagnosis/Index.vue'
import DiagnosisQ1 from '../views/diagnosis/Q1.vue'
import DiagnosisQ2 from '../views/diagnosis/Q2.vue'
import DiagnosisResult from '../views/diagnosis/Result.vue'
import DiagnosisResult2 from '../views/diagnosis/Result2.vue'
import Ranking from '@/views/diagnosis/Ranking.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    component: Index,
  },
  {
    path: '/diagnosis',
    component: Diagnosis,
    children: [
      {
        path: '',
        component: DiagnosisQ1,
      },
      {
        path: 'q1',
        component: DiagnosisQ1,
      },
      {
        path: 'q2',
        component: DiagnosisQ2,
      },
      {
        path: 'ranking',
        component: Ranking,
      },
      {
        path: 'result',
        component: DiagnosisResult,
      },
      {
        path: 'result2',
        component: DiagnosisResult2,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const dd = (window as any).digitalData as any
  if (dd) {
    dd.page.pageInfo.pageID = to.fullPath
    dd.page.pageInfo.pageName = to.fullPath
  }
  window.dispatchEvent(new CustomEvent('event-view-end'))
  next()
})

router.afterEach((to, from) => {
  const dataLayer = (window as any).dataLayer as any
  if (dataLayer) {
    dataLayer.push({event: 'optimize.activate'})
  }
})

export default router
